import { h } from 'preact';
import * as BaseComp from 'components/bolt/footer/footer.js';
// import s from 'components/bolt/footer/footer.sss';

export default class Footer extends BaseComp.default {

	render(props, state) {
		if (props?.store?.activePage !== 'aspectRatioTrailer') {
			return super.render(props, state);
		}

		const aspectRatioTrailerFullscreen = props?.store?.header?.aspectRatioTrailerFullscreen;
		if (aspectRatioTrailerFullscreen) {
			return;
		}
		
		const isMobileLandscape = props?.store?.client?.orientation === 'landscape' && props?.store?.client?.dimensions?.height < 700;
		return super.render({
			...props,
			scrollElem: isMobileLandscape ? window : undefined
		}, state);
	}

}
